export const BENEFICIARY_PERMISSION_LEVELS = {
    NONE: 0,
    VIEW: 1,
    EDIT: 2
}

export const numberToPermissions = (number) => {
    switch (number) {
    case BENEFICIARY_PERMISSION_LEVELS.NONE:
        return {};
    case BENEFICIARY_PERMISSION_LEVELS.VIEW:
        return { read: true };
    case BENEFICIARY_PERMISSION_LEVELS.EDIT:
        return { write: true, read: true };
    default:
        return {};
    }
}

export const permissionsToNumber = (permissions) => {
    if (permissions.write) {
        return BENEFICIARY_PERMISSION_LEVELS.EDIT;
    } else if (permissions.read) {
        return BENEFICIARY_PERMISSION_LEVELS.VIEW;
    } else {
        return BENEFICIARY_PERMISSION_LEVELS.NONE;
    }
}